__turbopack_context__.v({
  "container": "InterestPoint-module__Jr1-ja__container",
  "container__image": "InterestPoint-module__Jr1-ja__container__image",
  "container__info": "InterestPoint-module__Jr1-ja__container__info",
  "container__info__list": "InterestPoint-module__Jr1-ja__container__info__list",
  "container__info__title": "InterestPoint-module__Jr1-ja__container__info__title",
});
